$(() => {
  let body = $('body');

  // options / variants
  var form = $('#product-v3-form');
  if ($('.product-input-variant-group', form).length > 0) {
    let text = $('.product-input-variant-group').first().find('.product-input-variant-group-label > span:first-child').text().trim();
    $('.product-details-total-price-error').html(text.replace(window.gpb.pdp.texts.options.suffix ,''));
  } else {
    updatePrice($('input[type="hidden"].variant_id', form));
  }

  // select variant
  body.on('change', '#product-v3-form .variant_id', function() {
    let _t = $(this);
    product.updateQty(_t);
    product.updateAddToCart(_t, $('.product-details-cta'));

    // price
    updatePrice(_t);

    // slide gallery
    let data_media = _t.attr('data-media');
    let data_available = _t.attr('data-available') || (window.gpb.catalog_mode ? true : false);
    let gallery_slide = $('.product-details-gallery-slideshow div[data-media-id="'+data_media+'"]');
    if (data_available && gallery_slide.length > 0) {
      if (typeof gallery_slideshow_swiper !== 'undefined') {
        gallery_slideshow_swiper.slideTo(gallery_slide.parent().index());
      } else {
        let ivt = setInterval(function() {
          if (typeof gallery_slideshow_swiper !== 'undefined') {
            gallery_slideshow_swiper.slideTo(gallery_slide.parent().index());
            clearInterval(ivt);
          }
        }, 500);
      }
    }

    // metafields
    // platform
    let datas = _t.data();
    Object.keys(datas).forEach(function(data_key) {
      let data = datas[data_key];
      if (data_key.indexOf('platform_') >= 0) {
        let platform_name = data_key.replace('platform_', '');
        let platform_btn = $(`.product-details-ext-buttons .external-checkout-btn.${platform_name}-checkout-btn`);
        if (platform_btn.length > 0) {
          platform_btn.attr('href', data);
        }
        if (data == '') {
          platform_btn.addClass('hide');
        } else {
          platform_btn.removeClass('hide');
        }
      }
    });
    platform_btns = $(`.product-details-ext-buttons .external-checkout-btn`);
    platform_btns_hide = $(`.product-details-ext-buttons .external-checkout-btn.hide`);
    if (platform_btns.length == platform_btns_hide.length) {
      $('.product-details-ext-buttons .external-btn.coming-soon').removeClass('hide');
    } else {
      $('.product-details-ext-buttons .external-btn.coming-soon').addClass('hide');
    }


    // update url
    history.replaceState({
      variant: _t.val()
    }, '', window.location.pathname+'?variant='+_t.val());
  });
  // input variant / option
  body.on('change', '#product-v3-form .product-input-variant-group input[type="radio"]', function() {
    let _t = $(this);
    product.updateVariant($(this));

    // update option / variant group label
    let group_options = _t.parents('.product-input-variant-group-options');
    let group_label = group_options.prev('.product-input-variant-group-label');
    let group_label_selected = $('.product-input-variant-group-selected-value', group_label);
    let data_title = _t.attr('data-title');
    group_label_selected.html(data_title);
  });
  // input quantity
  body.on('change', '#product-v3-form #quantity', function() {
    updatePrice($(this));
  });
  body.on('click', '#product-v3-form .product-input-qty-btn', function() {
    updatePrice($(this));
  });
  function updatePrice(_t) {
    // custom fields
    // update add to cart btn
    let add_to_cart_text = $('select.variant_id option:selected, input.variant_id:checked, input[type="hidden"].variant_id').attr('data-add_to_cart_text');
    if (typeof add_to_cart_text !== 'undefined') {
      $('.btn-add-to-cart-text').html(add_to_cart_text);
    }

    // price
    let form = _t.parents('form');
    let qty = 1;
    let price_value = $('.product-details-total-price-value');
    let price_before = $('.product-details-total-price-before');
    let price_save = $('.product-details-total-price-save');
    let price_error = $('.product-details-total-price-error');

    price_value.html('');
    price_before.html('');
    price_save.html('');
    price_error.hide();

    let data_price_before = 0;
    let data_price_after = 0;
    $('select.variant_id option:selected, input.variant_id:checked, input[type="hidden"].variant_id', form).each(function(i) {
      qty = i == 0 ? $('#quantity').val() : 1;

      data_price_before += parseInt($(this).attr('data-price_before') || 0) * qty;
      data_price_after += parseInt($(this).attr('data-price_after') || 0) * qty;
    });

    if (!window.gpb.catalog_mode && data_price_after == 0) {
      price_error.show();
      return;
    }

    // update total price
    price_value.html(Shopify.formatMoney(data_price_after, window.money_format));
    if (data_price_before != '' && data_price_before > data_price_after) {
      price_before.html(Shopify.formatMoney(data_price_before, window.money_format));
      let data_price_save = data_price_before - data_price_after;
      price_save.html((window.gpb.pdp.texts.prices.save_price).replace('{{ price }}', Shopify.formatMoney(data_price_save,window.money_format)));
    }
  }
  // ?variant=*
  if ($('#product-v3-form .product-input-variant-group input[type="radio"]:checked').length > 0) {
    $('#product-v3-form .product-input-variant-group input[type="radio"]:checked').trigger('change');
  }

  // sticky
  body.on('click', '.product-sticky .product-details-cta button', function() {
    $('#product-v3-form').trigger('submit');
  });

  // application
  $(window).on('resize', updateApplicationLineClamp);
  updateApplicationLineClamp();
  function updateApplicationLineClamp() {
    let el = $('.product-details-application');
    el.addClass('active');
    let el_div = $('.product-details-application-tags', el);
    let el_height = ((14 * 1.4) + 6) * 2; // 2 lines max
    if (el_div.height() > el_height) {
      el.addClass('line-clamped');
      if ($('> button', el).length == 0) {
        el.append(`<button type="button">${el.attr('data-button-open')}</button>`);
      }
      el_div.css({
        height: el_height,
      });
    } else {
      el.removeClass('line-clamped')
        .find('> button').remove();
      el_div.removeAttr('style')
    }
  }
  let flag_application = false;
  body.on('click', '.product-details-application > button', () => {
    $('.product-details-application').toggleClass('line-clamped');
    flag_application = !flag_application;
    let el = $('.product-details-application');
    let btn = $('> button', el);
    let btn_text = flag_application ? el.attr('data-button-close') : el.attr('data-button-open');
    btn.html(btn_text);
  });

  // description
  $(window).on('resize', updateDescLineClamp);
  updateDescLineClamp();
  function updateDescLineClamp() {
    let el = $('.product-details-description');
    el.addClass('active');
    let el_div = $('> div', el);
    let el_height = 16 * 1.6 * 3; // 3 lines max
    if (el_div.height() > el_height) {
      el.addClass('line-clamped');
      if ($('> button', el).length == 0) {
        el.append(`<span class="delimiter">...</span> <button type="button" data-open="${el.attr('data-open')}" data-close="${el.attr('data-close')}">${el.attr('data-open')}</button>`);
      }
      el_div.css({
        height: el_height,
      });
    } else {
      el.removeClass('line-clamped')
        .find('> button').remove();
      el_div.removeAttr('style')
    }
  }
  body.on('click', '.product-details-description > button', function() {
    $('.product-details-description').toggleClass('line-clamped');
    let btn = $(this);
    let btn_t = btn.text();
    let btn_open_t = btn.attr('data-open');
    let btn_close_t = btn.attr('data-close');
    btn.html(btn_t==btn_open_t ? btn_close_t : btn_open_t);
  });

  // sticky menu
  $(window).on('scroll', scrollStickyCta);
  scrollStickyCta();
  function scrollStickyCta() {
    let s = $('.product-sticky');
    let c = $('.product-v3-details');
    let c_t = c.offset().top;
    let c_h = c.outerHeight();
    let H = c_t + c_h;
    let h = $(this).scrollTop();

    let cond = (window.innerWidth > 1024)
      ? (h > H)
      : (h < c_t || h > H);

    if (cond) {
      s.addClass('active');
    } else {
      s.removeClass('active');
    }
  }
  body.on('click', '.scrollspy-link', function(e) {
    let anchor = $(this).attr('href').replace('#', '');
    global.scrollToAnchor(anchor, $('.product-sticky').outerHeight());
    e.preventDefault();
  });

  // validation
  let product_input_label = $('.product-input-variant-group-label').data('name');
  let form_text = window.gpb.pdp.texts.form;
  let form_pdp = $('#product-v3-form');
  if (form_pdp.length > 0) {
    form_pdp.validate({
      ignore: '',
      rules: {
        id: {
          required: true,
        },
      },
      messages: {
        id: {
          required: `${form_text.error.id_required.replace('{{ label }}', product_input_label || form_text.option_label)}.`,
        },
      },
      errorLabelContainer: '.product-v3-form-error',
      invalidHandler: function(event, validator) {
        $('html,body').stop().animate({
          scrollTop: $('#product-v3-form').offset().top - ($('#static-header').height() || 0) - 20,
        }, 300);
        return true;
      },
      submitHandler: function(form) {
        product.setAddToCart(form);
        return false;
      }
    });
  }
});

var gallery_thumbs_swiper, gallery_slideshow_swiper;
$(window).on('load', () => {
  // gallery
  gallery_thumbs_swiper = new Swiper('.product-details-gallery-thumbs .swiper', {
    direction: 'horizontal',
    centerInsufficientSlides: true,
    spaceBetween: 12,
    slidesPerView: 'auto',
    freeMode: true,
    watchSlidesProgress: true,
    initialSlide: $('.product-details-gallery-thumbs .swiper-slide-active').index() || 0,
    pagination: {
      el: '.product-details-gallery-thumbs .swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.product-details-gallery-thumbs .swiper-button-next',
      prevEl: '.product-details-gallery-thumbs .swiper-button-prev',
    },
    scrollbar: {
      el: '.product-details-gallery-thumbs .swiper-scrollbar',
    },
  });
  gallery_slideshow_swiper = new Swiper('.product-details-gallery-slideshow .swiper', {
    direction: 'horizontal',
    initialSlide: $('.product-details-gallery-slideshow .swiper-slide-active').index() || 0,
    pagination: {
      el: '.product-details-gallery-slideshow .swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.product-details-gallery-slideshow .swiper-button-next',
      prevEl: '.product-details-gallery-slideshow .swiper-button-prev',
    },
    scrollbar: {
      el: '.product-details-gallery-slideshow .swiper-scrollbar',
    },
    thumbs: {
      swiper: gallery_thumbs_swiper
    },
  });
  // gallery_thumbs_swiper.on('slideChange', () => {
  //   gallery_slideshow_swiper.slideTo(gallery_thumbs_swiper.activeIndex);
  // });

  // image zoom
  $('.product-details-gallery-slideshow .image').on('click', (e) => {
    $(e.currentTarget).addClass('active');
  });
  $('.product-details-gallery-slideshow .image-zoom').on('click mouseleave', (e) => {
    $(e.currentTarget).prev('.image').removeClass('active');
  }).on('mousemove', zoomImage);
  function zoomImage(e) {
    var zoomer = e.currentTarget;
    e.offsetX ? offsetX = e.offsetX : offsetX = e.touches[0].pageX
    e.offsetY ? offsetY = e.offsetY : offsetX = e.touches[0].pageX
    x = offsetX/zoomer.offsetWidth*100
    y = offsetY/zoomer.offsetHeight*100
    zoomer.style.backgroundPosition = x + '% ' + y + '%';
  }

  // upsell
  const upsell_swiper = new Swiper('.product-upsell-slider .swiper', {
    direction: 'horizontal',
    spaceBetween: 8,
    slidesPerView: 'auto',
    freeMode: true,
    breakpoints: {
      768: {
        spaceBetween: 8,
      },
    },
    pagination: {
      el: '.product-upsell-slider .swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.product-upsell-slider .swiper-button-next',
      prevEl: '.product-upsell-slider .swiper-button-prev',
    },
    scrollbar: {
      el: '.product-upsell-slider .swiper-scrollbar',
    },
  });
  
  if ($('.product-upsell-slider > .swiper-div .swiper-slide').length > 1) {
    $(window).on('resize', updateUpsellSwiperWidth);
    updateUpsellSwiperWidth();
    function updateUpsellSwiperWidth() {
      let s = $('.product-upsell-slider > .swiper-div');
      s.removeAttr('style');

      let w = $('body').width();
      let c_w = $('.product-details-container').outerWidth();
      let s_w = s.outerWidth();
      s.css({
        width: `${s_w + ((w - c_w) / 2)}px`,
      });
    }
  }

  // crosssell
  const crosssell_swiper = new Swiper('.product-crosssell-slider .swiper', {
    direction: 'horizontal',
    spaceBetween: 8,
    slidesPerView: 'auto',
    freeMode: true,
    pagination: {
      el: '.product-crosssell-slider .swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.product-crosssell-slider .swiper-button-next',
      prevEl: '.product-crosssell-slider .swiper-button-prev',
    },
    scrollbar: {
      el: '.product-crosssell-slider .swiper-scrollbar',
    },
  });

  // box-content
  const box_content_swiper = new Swiper('.product-box-content-slider .swiper', {
    direction: 'horizontal',
    spaceBetween: 20,
    slidesPerView: 'auto',
    freeMode: true,
    breakpoints: {
      768: {
        spaceBetween: 20,
      },
    },
    pagination: {
      el: '.product-box-content-slider .swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.product-box-content-slider .swiper-button-next',
      prevEl: '.product-box-content-slider .swiper-button-prev',
    },
    scrollbar: {
      el: '.product-box-content-slider .swiper-scrollbar',
    },
  });
});